


























import Vue, { CreateElement, RenderContext } from 'vue';
import { defineComponent, provide, reactive, computed, onBeforeUpdate } from '@vue/composition-api';

export default defineComponent({
    name: 'WokDataGrid',

    props: {
        stickyHeader: {
            type: [Boolean, String],
            default: true
        },
        stickyTotals: {
            type: [Boolean, String],
            default: true
        },
        rowSize: {
            type: String,
            default: 'default',
            validator: (v: string) => /(default|compact|tall|form)/.test(v)
        },
        zebra: {
            type: [Boolean, String],
            default: false
        },
        groupDivider: {
            type: [Boolean, String],
            default: false
        }
    },

    setup(props, context) {
        const hasStickyHeader = computed(() => props.stickyHeader.toString() == 'true');
        const hasStickyTotals = computed(() => props.stickyTotals.toString() == 'true');
        const hasGroupDivider = computed(() => props.groupDivider.toString() == 'true');
        const hasZebra = computed(() => props.zebra.toString() == 'true');

        const wrapperClasses = computed(() => {
            return {
                'wok--data-grid__table': true,
                'wok--data-grid__table--sticky-header': hasStickyHeader.value,
                'wok--data-grid__table--sticky-totals': hasStickyTotals.value,
                'wok--data-grid__table--zebra': hasZebra.value,
                'wok--data-grid__table--group-divider': hasGroupDivider.value,
                [`wok--data-grid__table--${props.rowSize}`]: props.rowSize,
            };
        });

        return {
            wrapperClasses
        }
    }
})
